import React, { useState } from 'react'
import { Modal, OverlayTrigger, Spinner } from 'react-bootstrap'
import FeatherIcon from 'feather-icons-react';
import { renderTooltipClose } from 'utlis/helpers/Tooltips/CommonTooltips'
import { toast } from 'react-toastify';
import { deleteCustomer } from 'utlis/Apis/Customers_API';
import { CUSTOMER_DELETED_SUCCESSFULLY } from 'utlis/AppMessages/AppMessages';
import { ERROR_WHILE_DELETING_CUSTOMER } from 'utlis/AppMessages/AppMessages';
import { UNKNOWN_ERROR_OCCURED } from 'utlis/AppMessages/AppMessages';
import { connect } from 'react-redux';



function DeleteCustomer(props) {
    const { authState, show, closeModal, user_id, onDelete } = props
    const [modalLoading, setModalLoading] = useState(false)
    const handleDelete = () => {
        setModalLoading(true)
        toast.dismiss();
        const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }
        deleteCustomer(headers, user_id).then(res => {
            setModalLoading(false)
            const deletedData = res.data
            if (deletedData.success) {
                onDelete(user_id)
                closeModal()
                toast.success(CUSTOMER_DELETED_SUCCESSFULLY, {
                    autoClose: 1500,
                    onClose: closeModal
                })
            }

            if (deletedData.error) {
                console.log(ERROR_WHILE_DELETING_CUSTOMER, res)
                toast.dismiss();
                toast.error(ERROR_WHILE_DELETING_CUSTOMER, {
                    autoClose: 2500,
                    onClose: closeModal
                })
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE_DELETING_CUSTOMER} deleteCustomer `, err.message)
            toast.dismiss();
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500,
                onClose: closeModal
            })
        })
    }

    return (
        <Modal show={show} onHide={closeModal} centered size="md">
            <Modal.Body className="st-modal pad-20">
                <div className="app-modal-content modal-add-customer p-0 min-height-auto">
                    <div className="add-customer-form">
                        <div className="d-flex justify-content-between">
                            <div className="app-modal-title-wrapper mb-2 mb-lg-3 p-0">
                                <p className="app-modal-title text-capitalize st-fw-600 st-fs-24">Delete Customer</p>
                            </div>
                            <OverlayTrigger
                                placement={"bottom"}
                                overlay={renderTooltipClose}
                            >
                                <button
                                    className="st-round-btn st-btn-transparent  st-btn-sm d-flex align-items-center justify-content-center"
                                    onClick={props.closeModal && props.closeModal}
                                >
                                    <FeatherIcon
                                        icon="x"
                                        size="24"
                                        className="icon border st-default-rounded-block" />
                                </button>
                            </OverlayTrigger>
                        </div>
                        <div className="app-card customer-address-modal" >
                            <div className="app-card-content border st-default-rounded-block pad-20">
                                <div className="st-form d-flex justify-content-center flex-wrap align-items-center mb-0">
                                    <p className="st-fs-20 st-fw-600 mb-3">
                                        Are you sure you want to delete this customer?
                                    </p>
                                    {modalLoading && (
                                        <div className="app-modal-loading-overlay position-absolute h-100 w-100 d-flex align-items-center justify-content-center">
                                            <Spinner animation="border" />
                                        </div>
                                    )}

                                    <div className="d-flex">
                                        <button
                                            type="button"
                                            disabled={modalLoading}
                                            className="st-btn st-btn-gray no-min-width d-flex align-items-center justify-content-center me-1"
                                            onClick={closeModal}
                                        >
                                            <span>Cancel</span>
                                        </button>
                                        <button
                                            type="button"
                                            className="st-btn st-btn-primary no-min-width d-flex align-items-center justify-content-center"
                                            disabled={modalLoading}
                                            onClick={handleDelete}
                                        >
                                            <span>Delete</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal >
    )
}

const getDataFromStore = state => {
    return {
        authState: state.auth,
    };
}

export default connect(getDataFromStore)(DeleteCustomer)
